import { Grid, Stack } from "@mui/material";
import Feedback from "components/common/Feedback";
import PageTitle from "components/common/PageTitle";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DISPLAY_TYPE } from "utils/CommonConstants";
import { clearChildFilters, resetAllFilters } from "../AboveProperty/AboveProperty.slice";
import GlobalSearch from "../GlobalSearch";
import ReleaseHighlight from "../ReleaseHighlight";
import Overview from "../dashboard/Overview";
import RecentlyViewed from "../dashboard/RecentlyViewed";
import CorpView from "./CorpView";
import SaveList from "./CorpView/Dialog/SaveList";
import "./index.scss";

export default function CorpDashboard({ label }: any) {
  const dispatch = useAppDispatch();
  const savedFilter: any = useAppSelector((state) => state.filters.savedFilter);

  useEffect(() => {
    dispatch(clearChildFilters());
  }, []);

  useEffect(() => {
    dispatch(resetAllFilters());
  }, []);

  return (
    <div className="corp_dashboard">
      <Feedback form="saveFilterList" />
      <Grid container className="title">
        <PageTitle label={label} />
        <GlobalSearch />
      </Grid>
      <Grid container className="container-main">
        <Grid item md={8} className="my-view">
          <CorpView selectedListType={"default"} view="dashboard" selectedList={savedFilter?.default?.[0]} />
        </Grid>
        <Grid item md={3.5} className="container-right-grid">
          <Stack className="container-right" direction="column">
            <ReleaseHighlight />
            <Overview type={DISPLAY_TYPE.bookmarkedPropertiesPlans} />
            <RecentlyViewed />
          </Stack>
        </Grid>
      </Grid>
      <SaveList />
    </div>
  );
}
